import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";

export const OrderTableSkeleton: React.FC<{ rowCount?: number }> = ({ rowCount = 5 }) => {
  return (
    <Card className="border-0 shadow-sm">
      <CardContent className="p-0">
        <div className="relative w-full overflow-auto">
          <Table>
            <TableHeader className="bg-gray-50">
              <TableRow className="border-b border-gray-200">
                {/* 9 columns for order list */}
                {[...Array(9)].map((_, i) => (
                  <TableHead key={i} className="text-gray-600 font-medium py-4">
                    <Skeleton className="h-4 w-20" />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {[...Array(rowCount)].map((_, rowIndex) => (
                <TableRow key={rowIndex} className="border-b border-gray-100">
                  {[...Array(9)].map((_, colIndex) => (
                    <TableCell key={colIndex} className="py-3">
                      <Skeleton className="h-4 w-full" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}; 